'use strict';

const { isNatural, validate } = require('fpx');

class PublicError extends Error {
  get name() {
    return this.constructor.name;
  }
  constructor(status, body) {
    validate(isNatural, status);
    super();
    this.body = body;
    this.status = status;
  }
}
exports.PublicError = PublicError;

class ReadinessError extends PublicError {}
exports.ReadinessError = ReadinessError;

class TimeoutError extends PublicError {
  constructor(body) {
    super(408, body);
  }
}
exports.TimeoutError = TimeoutError;



// WEBPACK FOOTER //
// ./src/shared/errors.js